/** @module global/request/sports */
import RequestUtility from './request';

const SERVICE_URL =
  window.location.hostname === 'www.getfoodfight.link'
    ? 'https://d2if4tc6g5.execute-api.us-east-1.amazonaws.com/prod'
    : 'https://v5j4xszs7i.execute-api.us-east-1.amazonaws.com/prod';

const util = new RequestUtility(SERVICE_URL, {
  defaultMethod: 'POST',
});

/**
 * Fetches sports feed data from the server
 * @param {string} bearerToken The bearer token to use for authentication
 * @param {Object} params The parameters for the request (league, source_type, limit, next_token, etc.)
 * @returns {Promise<Object>} The sports feed data
 */
async function getSportsFeed(bearerToken, params) {
  const response = await util.authorizedRequest(
    'games/sports-feed',
    {
      bearerToken,
    },
    params,
  );
  return response;
}

export default getSportsFeed;
